"use client"

import React, {useState} from 'react';
import Header2 from "@/app/(index)/header2";
import cx from "clsx";
import {Noto_Sans_TC} from 'next/font/google';
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import Footer from "@/app/(index)/footer";
import Bread from "@/app/(index)/bread";
import styles from '../index.module.css'
import {UnstyledButton} from "@mantine/core";
import LinkItem from "@/app/(index)/related-links/link";
import {useMediaQuery} from "@mantine/hooks";

const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

export default function Page() {
    const { fontSize, lang } = useGlobalStateStore();
    const [tab, setTab] = useState<number>(1);
    const loadCurrentFontSize = (s: number, m: number, l: number) => {
        if(fontSize == 0) return `text-[${s}px]`;
        else if(fontSize == 1) return `text-[${m}px]`;
        else if(fontSize == 2) return `text-[${l}px]`;
    }

    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');
    return (
        <div className={cx("min-h-screen flex flex-col justify-between", notoSansTC.className)}>
            <div>
                <Header2/>
                {
                    mediaQueryLessSM && (
                        <Bread name_c="關於科政中心 - 相關連結" name_e="Related Links"/>
                    )
                }
                <div
                    className={cx("mx-auto mb-[100px]", mediaQueryLessSM ? 'w-[1250px]' : 'w-full mt-[100px] px-[10px]')}>
                    <div
                        className={cx("bg-[url('/images/title_topBG.png')] bg-[length:100%_5px] bg-no-repeat bg-top inline-block pt-[15px] text-[#5b5b5b] text-[35px] font-bold")}>
                        {lang == "tw" ? "相關連結" : "Related Links"}
                    </div>

                    <div
                        className={cx("flex gap-1 border-b border-[#79b7b4]", mediaQueryLessSM ? 'justify-end' : 'mt-10 w-full')}>
                        <UnstyledButton onClick={() => setTab(1)}>
                            <div
                                className={cx(tab === 1 ? styles.bookmarkBG1Active : styles.bookmarkBG1,
                                    "text-white py-[15px] px-[25px] font-bold", mediaQueryLessSM ? loadCurrentFontSize(14, 18, 20) : 'text-[14px]')}>
                                {lang == "tw" ? "國研院所屬單位" : "NIAR"}
                            </div>
                        </UnstyledButton>
                        <UnstyledButton onClick={() => setTab(2)}>
                            <div
                                className={cx(tab === 2 ? styles.bookmarkBG1Active : styles.bookmarkBG1,
                                    "text-white py-[15px] px-[25px] font-bold", mediaQueryLessSM ? loadCurrentFontSize(14, 18, 20) : 'text-[14px]')}>
                                {lang == "tw" ? "本國相關單位" : "Domestic"}
                            </div>
                        </UnstyledButton>
                        <UnstyledButton onClick={() => setTab(3)}>
                            <div
                                className={cx(tab === 3 ? styles.bookmarkBG1Active : styles.bookmarkBG1,
                                    "text-white py-[15px] px-[25px] font-bold", mediaQueryLessSM ? loadCurrentFontSize(14, 18, 20) : 'text-[14px]')}>
                                {lang == "tw" ? "國外相關單位" : "International"}
                            </div>
                        </UnstyledButton>
                    </div>


                    {
                        (tab == 1 && lang == "tw") && (
                            <div className="flex flex-col">
                                <LinkItem name="國家實驗研究院" link="https://www.niar.org.tw"/>
                                <LinkItem name="台灣半導體研究中心" link="https://www.tsri.org.tw"/>
                                <LinkItem name="國家生物模式中心" link="https://www.ncb.niar.org.tw"/>
                                <LinkItem name="國家高速網路與計算中心" link="https://www.nchc.org.tw"/>
                                <LinkItem name="國家地震工程研究中心" link="https://www.ncree.niar.org.tw"/>
                                <LinkItem name="台灣海洋科技研究中心" link="https://www.tori.niar.org.tw"/>
                                <LinkItem name="國家儀器科技研究中心" link="https://www.ncir.niar.org.tw/"/>
                            </div>
                        )
                    }

                    {
                        (tab == 1 && lang == "en") && (
                            <div className="flex flex-col">
                                <LinkItem name="National Institutes of Applied Research (NIAR)"
                                          link="https://www.niar.org.tw/en"/>
                                <LinkItem name="National Center for Biomodels (NCB)"
                                          link="https://www.ncb.niar.org.tw/eng/index.asp"/>
                                <LinkItem name="National Center for Research on Earthquake Engineering(NCREE)"
                                          link="https://www.ncree.niar.org.tw/home/switchLang/english"/>
                                <LinkItem name="National Center for High-performance Computing(NCHC)"
                                          link="https://www.nchc.org.tw/Home/ChangeLang?lang=2"/>
                                <LinkItem name="Taiwan Semiconductor Research Institute (TSRI)"
                                          link="https://www.tsri.org.tw/english/"/>
                                <LinkItem name="Taiwan Ocean Research Institute (TORI)"
                                          link="https://www.tori.niar.org.tw/ETORI/eDefault.aspx"/>
                                <LinkItem name="National Center for Instrumentation Research (NCIR)"
                                          link="https://www.tiri.narl.org.tw/"/>
                            </div>
                        )
                    }
                    {
                        (tab == 2 && lang == "tw") && (
                            <div className="flex flex-col">
                                <LinkItem name="國家科學及技術委員會 (前身為科技部)" link="https://www.nstc.gov.tw"/>
                                <LinkItem name="經濟部" link="https://www.moea.gov.tw"/>
                                <LinkItem name="教育部" link="https://www.edu.tw"/>
                                <LinkItem name="農業部" link="https://www.moa.gov.tw"/>
                                <LinkItem name="台灣經濟研究院" link="https://www.tier.org.tw"/>
                                <LinkItem name="財團法人工業技術研究院" link="https://www.itri.org.tw"/>
                                <LinkItem name="財團法人資訊工業策進會" link="https://www.iii.org.tw"/>
                                <LinkItem name="中華民國科技管理學會" link="https://www.csmot.org.tw"/>
                                <LinkItem name="中華民國資訊安全學會" link="https://www.ccisa.org.tw"/>
                                <LinkItem name="中華民國圖書館學會" link="https://www.lac.org.tw"/>
                                <LinkItem name="中華圖書資訊館際合作協會" link="https://www.ilca.org.tw"/>
                                <LinkItem name="數位發展部" link="https://moda.gov.tw"/>
                                <LinkItem name="國家資通安全研究院" link="https://www.nics.nat.gov.tw"/>
                            </div>
                        )
                    }
                    {
                        (tab == 2 && lang == "en") && (
                            <div className="flex flex-col">
                                <LinkItem name="National Science and Technology Council"
                                          link="https://www.nstc.gov.tw/?l=en"/>
                                <LinkItem name="Ministry of Economic Affairs"
                                          link="https://www.moea.gov.tw/MNS/english/home/English.aspx?menu_id=1337"/>
                                <LinkItem name="Ministry of Education" link="https://english.moe.gov.tw/mp-1.html"/>
                                <LinkItem name="Ministry of Agriculture" link="https://eng.moa.gov.tw/index.php"/>
                                <LinkItem name="Taiwan Institute of Economic Research" link="https://english.tier.org.tw/"/>
                                <LinkItem name="Industrial Technology Research Institute"
                                          link="https://www.itri.org.tw/english/index.aspx"/>
                                <LinkItem name="Institute for Information Industry" link="https://web.iii.org.tw/en"/>
                                <LinkItem name="Chinese Cryptology and Information Security Association"
                                          link="https://ccisa.org.tw/indexen.html"/>
                                <LinkItem name="Library Association of the Republic of China (Taiwan)"
                                          link="https://www.lac.org.tw"/>
                                <LinkItem name="Interlibrary Cooperation Association" link="http://www.ilca.org.tw/"/>
                                <LinkItem name="Ministry of Digital Affairs" link="https://moda.gov.tw/en/"/>
                                <LinkItem name="National Institute of Cyber Security"
                                          link="https://www.nics.nat.gov.tw/en/"/>
                            </div>
                        )
                    }
                    {
                        tab == 3 && (
                            <div className="flex flex-col">
                                <LinkItem name="Organisation for Economic Cooperation and Development (OECD)"
                                          link="https://www.oecd.org"/>
                                <LinkItem name="National Science Foundation (NSF)" link="https://www.nsf.gov"/>
                                <LinkItem name="National Academy of Sciences (NAS)" link="https://www.nasonline.org"/>
                                <LinkItem name="The American Association for the Advancement of Science (AAAS)"
                                          link="https://www.aaas.org"/>
                                <LinkItem name="Japan Science and Technology Agency (JST)" link="https://www.jst.go.jp"/>
                                <LinkItem name="National Institute of Science and Technology Policy (NISTEP)"
                                          link="https://www.nistep.go.jp"/>
                                <LinkItem name="Korea Institute of Science and Technology Information (KISTI)"
                                          link="https://www.kisti.re.kr"/>
                                <LinkItem name="Korea Institute of S&T Evaluation and Planning (KISTEP)"
                                          link="https://www.kistep.re.kr"/>
                                <LinkItem name="Science and Technology Policy Institute (STEPI)"
                                          link="https://www.stepi.re.kr"/>
                                <LinkItem name="Fraunhofer ISI" link="https://www.isi.fraunhofer.de/isi-de/index.php"/>
                                <LinkItem name="Technopolis" link="https://www.technopolis-group.com"/>
                            </div>
                        )
                    }
                </div>
            </div>
            <Footer/>
        </div>
    );
}
